import React from 'react';
import { Dimmer, Loader, Container } from 'semantic-ui-react';

const LoaderPage = (props) => {
  return(
    <Container>
      <Dimmer inverted={true} active={props.loading}>
        <Loader/>
      </Dimmer>
    </Container>
  )
}

export default LoaderPage;



// WEBPACK FOOTER //
// ./src/components/LoaderPage.js